var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-wrap"},[_c('a',{attrs:{"target":"_blank","href":"https://github.com/jusfoun-FE/spa-development-PC/blob/master/README.md"}},[_vm._v("VUE-PC模板使用说明")]),_vm._v(" "),_c('div',{staticClass:"theme-wrapper"},[_c('theme')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48d42bd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/home.vue
// module id = null
// module chunks = 